import { render } from "./ReligousList.vue?vue&type=template&id=fa6d54ee&scoped=true"
import script from "./ReligousList.vue?vue&type=script&lang=js"
export * from "./ReligousList.vue?vue&type=script&lang=js"

import "./ReligousList.vue?vue&type=style&index=0&id=fa6d54ee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa6d54ee"]])

export default __exports__